/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar-range-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M7 12h2v2H7v-2m14-6v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h1V2h2v2h8V2h2v2h1a2 2 0 012 2M5 8h14V6H5v2m14 12V10H5v10h14m-4-6h2v-2h-2v2m-4 0h2v-2h-2v2z"/>'
  }
})
